module.exports = __webpack_public_path__ + "static/media/oshiri.aab993e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/oshiri.png
// module id = 1706
// module chunks = 1